function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.596v13.979c0 .892.579 1.68 1.426 1.937L10 29.506V11.305L4.574 9.659C3.291 9.269 2 10.24 2 11.596zM23 22.828l-1.414-1.414a39.577 39.577 0 01-.586-.6v6.602l5.367 1.81c1.295.436 2.633-.54 2.633-1.919v-11.3c-1.819 2.568-3.913 4.734-4.586 5.407L23 22.828zM12 12v18l7-2.542v-8.875c-1.755-2.081-3.817-4.914-4.635-7.51L12 12z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 9a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zM30 9a7 7 0 10-14 0c0 4 7 11 7 11s7-7 7-11z",
    fill: props.color
  }));
}

export default SvgIconMapRexFilled;